module.exports = __webpack_public_path__ + "img/fd_cj.64b276f9.png";